class JsTrending extends HTMLElement {
  connectedCallback() {
    this.root = this.querySelector('[data-trending-swiper]');
    if (!this.root) return;

    this.prevEl = this.querySelector('[data-trending-prev]');
    this.nextEl = this.querySelector('[data-trending-next]');
    this.scrollbarEl = this.querySelector('[data-trending-scrollbar]');

    this.ready().then(() => this.init());
  }

  disconnectedCallback() {
    this.destroy();
  }

  ready() {
    if (window.Swiper) return Promise.resolve();

    return new Promise((resolve) => {
      const script = document.querySelector('script[src*="swiper-bundle"]');

      if (script) {
        script.addEventListener('load', () => resolve(), { once: true });
      }

      const timer = window.setInterval(() => {
        if (!window.Swiper) return;
        window.clearInterval(timer);
        resolve();
      }, 50);
    });
  }

  gutter() {
    const section = this.closest('.section');
    if (!section) return 16;
    const start = parseFloat(getComputedStyle(section).paddingInlineStart);
    return Number.isFinite(start) && start > 0 ? start : 16;
  }

  applyOffsets(swiper = this.swiper) {
    if (!swiper) return false;
    const gutter = this.gutter();
    if (swiper.params.slidesOffsetBefore === gutter && swiper.params.slidesOffsetAfter === gutter) {
      return false;
    }
    swiper.params.slidesOffsetBefore = gutter;
    swiper.params.slidesOffsetAfter = gutter;
    return true;
  }

  init() {
    if (!window.Swiper || !this.root || this.swiper) return;

    const gutter = this.gutter();

    const options = {
      slidesPerView: 'auto',
      // Step a whole screen of cards, so the arrows never leave a card half cut.
      slidesPerGroupAuto: true,
      slidesOffsetBefore: gutter,
      slidesOffsetAfter: gutter,
      spaceBetween: 8,
      watchOverflow: true,
      resistanceRatio: 0.65,
      a11y: {
        enabled: true,
        prevSlideMessage: this.prevEl?.dataset.label || 'Previous',
        nextSlideMessage: this.nextEl?.dataset.label || 'Next',
      },
      breakpoints: {
        1000: {
          spaceBetween: 16,
        },
      },
      on: {
        beforeResize: (swiper) => this.applyOffsets(swiper),
      },
    };

    // Sections can be configured without the arrow row. Swiper throws while
    // reading `el` if these modules are handed empty config, which leaves the
    // rail un-offset, so only pass them when the elements are really there.
    if (this.scrollbarEl) {
      options.scrollbar = { el: this.scrollbarEl, draggable: true, hide: false, snapOnRelease: true };
    }
    if (this.prevEl && this.nextEl) {
      options.navigation = { prevEl: this.prevEl, nextEl: this.nextEl };
    }

    this.swiper = new window.Swiper(this.root, options);

    this.resizeObserver = new ResizeObserver(() => {
      if (!this.swiper) return;
      if (this.applyOffsets()) this.swiper.update();
    });
    this.resizeObserver.observe(this.closest('.section') || this);
  }

  destroy() {
    this.resizeObserver?.disconnect();
    this.resizeObserver = null;
    if (!this.swiper) return;
    this.swiper.destroy(true, true);
    this.swiper = null;
  }
}

if (!window.customElements.get('js-trending')) {
  window.customElements.define('js-trending', JsTrending);
}
